// extracted by css-extract-rspack-plugin
export default {"participantAvatar":"ParticipantsList-module__participantAvatar__weyWT","participantLimitNotice":"ParticipantsList-module__participantLimitNotice__AnJMC"};